// FibaBadge — the agent trust signal. Batch 2 (FIBA verification).
//
// Non-empty license number → "FIBA Licensed" pill that links to FIBA's
// public agent search (the search is dropdown-only, so there's no deep-link
// param) and shows the number so a coach can paste + verify. Null/empty →
// a muted "Unverified" pill. NO automated verification: the number is
// self-entered and the coach verifies via the link. Rendered on the agent's
// own profile, the agent dashboard, and the "Represented by" card on every
// player profile.

import { ExternalLink } from 'lucide-react'

const FIBA_SEARCH_URL = 'https://about.fiba.basketball/en/search/agents'

export default function FibaBadge({
  licenseNumber,
}: {
  licenseNumber: string | null
}) {
  const num = licenseNumber?.trim()
  if (!num) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium bg-hoop-bg text-hoop-text-2">
        Unverified
      </span>
    )
  }
  return (
    <a
      href={FIBA_SEARCH_URL}
      target="_blank"
      rel="noreferrer"
      title="Verify on FIBA's licensed-agent search"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium bg-hoop-green-bg text-hoop-green hover:opacity-90 transition-opacity"
    >
      FIBA Licensed
      <span className="font-normal opacity-80">· {num}</span>
      <ExternalLink className="w-3 h-3" />
    </a>
  )
}
